export const createPage = (context) => (type, id, cb) => ({
    type: "CMS.PAGES.CREATE",
    payload: { type, id, cb },
    context,
});
